import getCookieValue from 'onyx-common/getCookieValue'

const getOnyxVariation = () => {
  return getCookieValue('onyxVariation')
}

export default getOnyxVariation
